import Cookies from 'js-cookie'

const tokenKey = 'token_edcwifi'
const userinfoKey = 'userinfo'
const savepwdKey = 'pwdKey'

export function getSavePwd() {
  return Cookies.get(savepwdKey)
}

export function setSavePwd(userinfo) {
  return Cookies.set(savepwdKey, userinfo)
}

export function delSavePwd() {
  return Cookies.remove(savepwdKey)
}

export function getUserInfo() {
  return Cookies.get(userinfoKey)
}

export function setUserInfo(userinfo) {
  return Cookies.set(userinfoKey, userinfo)
}

export function delUserInfo() {
  return Cookies.remove(userinfoKey)
}

export function getToken() {
  return Cookies.get(tokenKey)
}

export function setToken(token) {
  return Cookies.set(tokenKey, token)
}

export function delToken() {
  return Cookies.remove(tokenKey)
}

export function clearAll(){
  return Cookies.remove(userinfoKey)
  return Cookies.remove(tokenKey)
}




// WEBPACK FOOTER //
// ./src/utils/user.js